import htmlFrag from './elections.frag.html';
import './style.css';

export async function initElectionsFlipped () {
  const $dom = document.querySelector('#elections-flipped-container');
  $dom.outerHTML = htmlFrag;
}
